<template>
  <div class="client-detail__card">
    <div class="card-header">
      <div class="left">
        <div class="text-left approval" :class="{'approval-exists' : isApprovalLetterExists}">
          <v-icon v-if="isApprovalLetterExists" class="exists-approval">
            check
          </v-icon>
          <v-icon v-else class="non-exists-approval">
            close
          </v-icon>
          <p>Approval Letter</p>
        </div>
        <div v-if="clientForCard" class="details">
          <p>
            Goal Date:
            <br>
            <b v-if="clientForCard.goalDate">{{ formatDate(clientForCard.goalDate) }}</b>
          </p>
          <p>
            Price Range:
            <br>
            <b>
              <template v-if="clientForCard.priceMin && clientForCard.priceMax">
                {{ formatPrice(clientForCard.priceMin) }} - {{ formatPrice(clientForCard.priceMax) }}
              </template>
            </b>
          </p>
        </div>
      </div>
      <div v-if="clientForCard" class="avatar">
        <v-avatar :color="colors[clientForCard.name[0]]">
          <img v-if="clientForCard.avatar" src="clientForCard.avatar" alt="">
          <span v-else class="white--text headline">{{ clientForCard.name | initials }}</span>
        </v-avatar>
      </div>
      <slot name="close-button" />
    </div>
    <!-- Displaying the selected client details -->
    <template v-if="clientForCard">
      <div class="client-detail__title">
        {{ clientForCard.name }}
      </div>
      <p class="email">
        {{ clientForCard.email }}
      </p>
      <p
        class="phone"
        style="color: $hwayzBlack"
      >
        phone: {{ clientForCard.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/,"$1.$2.$3") }}
      </p>
    </template>
    <!-- <div class="client-detail__buying-stage">
      <div class="client-detail__buying-stage--title">
        Homebuying Stage
      </div>
      <v-layout wrap>
        <v-flex
          v-for="(item, i) in homeBuyingStages"
          :key="i"
          xs12
          sm6
          md12
          lg6
          class="client-detail__buying-stage--name"
        >
          <v-icon
            :color="getStatusColor(homeBuyingStageColors)"
            small
          >
            {{ getStatusIcon(homeBuyingStageColors) }}
          </v-icon>
          <span>{{ item }}</span>
        </v-flex>
      </v-layout>
    </div> -->
    <div class="client-detail__wants text-left">
      <div>Wants:</div>
      <v-chip
        v-for="(item, i) in getClientHomePreferences('Want')"
        id="chips"
        :key="i"
        class="client-detail__chips"
        small
      >
        {{ item }}
      </v-chip>
    </div>
    <div class="client-detail__needs text-left">
      <div>Needs:</div>
      <v-chip
        v-for="(item, i) in getClientHomePreferences('Need')"
        id="chips"
        :key="i"
        class="client-detail__chips"
        small
      >
        {{ item }}
      </v-chip>
    </div>
    <div class="text-xs-center">
      <v-btn
        v-if="!isClientDetailPage"
        round
        depressed
        flat
        class="btn-client-detail"
        @click="openClientDetailPage"
      >
        <v-icon class="details-button-icon">
          assignment_ind
        </v-icon>VIEW CLIENT DETAIL
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import {
  status,
  homeBuyingStages,
  homeBuyingStageColors
} from './client-fake-data'
import avatarColors from '../../utils/avatarColors'
import currencyFormatter from 'currency-formatter'
import moment from 'moment'

export default {
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },

  props: {
    clientDetailForCard: {
      type: Object,
      default: () => {
        return null
      }
    }
  },

  data() {
    return {
      homeBuyingStages,
      homeBuyingStageColors,
      colors: avatarColors
    }
  },

  computed: {
    ...mapState('client', ['clientData']),
    ...mapGetters('agent', ['getClient']),

    clientForCard() {
      return this.clientDetailForCard
        ? this.clientDetailForCard
        : this.clientData
    },

    isApprovalLetterExists() {
      const client = this.clientForCard
      return client && client.media && client.media.find(item => item.type === 'approval_letter')
    },

    isClientDetailPage() {
      return this.$route.name === 'client-detail'
    }
  },
  methods: {
    ...mapActions('agent', ['setSearchedClient']),
    /**
     * Returns the icon for home buying status
     *
     * @param {String} value Home buying status
     * @public
     */

    getStatusIcon(value) {
      if (value === status.GREEN) {
        return 'fiber_manual_record'
      } else {
        return 'radio_button_unchecked'
      }
    },
    /**
     * Returns the color of home buying status
     *
     * @param {String} value Home buying status
     * @public
     */
    getStatusColor(value) {
      if (value === status.GREEN) return 'green'
      else return 'orange'
    },

    /**
     * Returns home preferences that are added by client
     *
     * @param {string} preference 'Want' or 'Need'
     * @public
     */
    getClientHomePreferences(preference) {
      if (this.clientForCard && this.clientForCard.homePrefs) {
        return this.clientForCard.homePrefs.options
          .filter(pref => pref.wantNeed === preference)
          .map(item => {
            if (item.minValue) {
              return item.text + '-' + item.minValue
            }
            return item.text
          })
      }
      return []
    },
    openClientDetailPage() {
      this.setSearchedClient(this.clientDetailForCard)
      return this.$router.push({ name: 'client-detail' })
    },
    formatPrice(price) {
      return currencyFormatter.format(price, { code: 'USD' })
    },
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY')
    }
  }
}
</script>

<style scoped lang='sass'>
.client-detail__card
  border-radius: 1.5rem
  box-shadow: 0.1rem 0.1rem 0.5rem rgba(0, 0, 0, 0.2)
  padding: 2rem
  background-color: $hwayzWhite
  position: relative
  text-align: center
  width: 36rem

.client-detail__title
  font-size: $hwayzFont1rem8
  margin-bottom: 1rem
  margin-top: 1rem
  text-transform: capitalize
  color: $hwayzBlack

.email
  color: $hwayzLink
  font-size: $hwayzFont1rem

.phone
  font-size: $hwayzFont1rem

.client-detail__icon
  border: 0.5px solid $hwayzMediumGray
  padding: 2rem
  border-radius: 100%

.client-detail__card p
  margin-bottom: 0.5rem

.client-detail__chips
  color: $hwayzWhite !important

.client-detail__buying-stage
  background-color: $hwayzfb
  border-radius: 1.5rem
  margin: 6rem 0
  padding: 2rem 15%

@media only screen and ( max-width: 1280px)
  padding: 1rem 7%
.client-detail__buying-stage--title
  margin-bottom: 2rem
  font-size: $hwayzFont1rem2

.client-detail__buying-stage--name
  text-align: left !important
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  font-size: $hwayzFont1rem

.client-detail__buying-stage span
  display: inline-block
  margin-bottom: 1.3rem
  padding-left: 0.5rem
  font-size: $hwayzFont1rem !important
  color: $hwayzBlack

.client-detail__wants,
.client-detail__needs
  margin-bottom: 3rem
  margin-top: 4rem
  height: 100px
  overflow: auto
.client-detail__wants #chips
  background-color: $hwayzDarkenGreen
.client-detail__needs #chips
  background-color: $hwayzTapestry

#chips
  font-size: $hwayzFont1rem
.client-detail__wants div,
.client-detail__needs div
  color: $hwayzBlack
  position: absolute
  margin-top: -20px
.client-detail__wants
  top: 40%
.client-detail__needs
  top: 63%

.card-header
  background-color: transparent
  display: grid
  grid-template-columns: 6fr 4fr 6fr
  grid-template-areas: "approval" "avatar" "details"
  border: 0

.approval
  grid-area: "approval"
  display: inline-flex
  justify-self: flex-end
  align-self: center
  float: left
  &.approval-exists p
    color: $hwayzLink

.approval p
  margin-left: 3px
  font-size: 1.2em
  font-size: $hwayzFont1rem

.exists-approval
  font-size: 1.4rem
  padding-bottom: 2.5%
  color: $hwayzGreen !important

.non-exists-approval
  font-size: 1.4rem
  padding-bottom: 2.5%

.avatar
  grid-area: "avatar"
  align-self: center

.details
  grid-area: "details"
  font-size: $hwayzFont1rem
  justify-self: flex-end
  align-self: center
  float: left

.details p
  display: flex
  float: left

.corner
  position: absolute
  top: 5px
  right: 5px
  cursor: pointer
p,b
  color: $hwayzBlack
.btn-client-detail
  border: 1px solid $hwayzBlack
  font-size: $hwayzFont1rem2
  height: 25px
  min-width: 50%
  box-shadow: none
  cursor: pointer
  overflow: hidden
  outline: none
.details-button-icon
  width: 15px
  height: 15px
  padding-right: 5px
@media only screen and (min-width: 1264px)
  .client-detail__buying-stage
    margin: 0px

  .client-detail__buying-stage span
    font-size: $hwayzFont1rem
  #chips
  font-size: $hwayzFont1rem
  .close
    cursor: pointer
</style>
